"use client";

import { useEffect } from "react";
import { authService } from "@/services/auth.service";
import { useAuthStore } from "@/store/auth.store";
import { ApiError } from "@/lib/api-client";

export default function AuthInitializer() {
  const setUser = useAuthStore((s) => s.setUser);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const profile = await authService.getProfile();
        if (mounted && profile) setUser(profile);
      } catch (err) {
        // Only wipe the auth state for definitive authentication rejections
        // (401 Unauthorized / 403 Forbidden). Network errors, 5xx, and other
        // transient failures must NOT log the user out — they may still have a
        // valid session that is temporarily unreachable. The /api/auth/me route
        // already attempts a token refresh internally before returning 401, so
        // a 401 here means both tokens are definitively invalid.
        if (!mounted) return;
        const status =
          err instanceof ApiError
            ? err.status
            : typeof (err as { status?: number })?.status === "number"
            ? (err as { status: number }).status
            : null;
        if (status === 401 || status === 403) {
          clearAuth();
        }
        // All other errors (network failure, 5xx, parse error, etc.) are
        // silently swallowed — the user stays logged in with whatever state
        // is already in the store.
      }
    })();
    return () => {
      mounted = false;
    };
  }, [setUser, clearAuth]);

  return null;
}
